import React, { createContext, useContext, useMemo } from 'react';
import { BUILDER_POLICY } from '../policy/planPolicy';

const AccountContext = createContext(null);

/** Minimal account context — builder-only, no billing or usage tracking. */
export function AccountProvider({ children }) {
  const value = useMemo(
    () => ({
      account: { displayName: 'Builder' },
      policy: BUILDER_POLICY,
    }),
    []
  );

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>;
}

export function useAccount() {
  const ctx = useContext(AccountContext);
  if (!ctx) {
    throw new Error('useAccount must be used inside AccountProvider');
  }
  return ctx;
}
